import { Controller } from "@hotwired/stimulus";

// Controller: ptd-toggle
// Usage:
// <input data-controller="ptd-toggle"
//        data-ptd-toggle-url-value="/promotion_table_definitions/123"
//        data-action="change->ptd-toggle#toggle click->ptd-toggle#stop">
export default class extends Controller {
  static values = {
    url: String
  }

  stop(event) {
    // Prevent navigating the wrapping link card
    event.stopPropagation();
  }

  async toggle(event) {
    const checked = event.currentTarget.checked;
    try {
      const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      const res = await fetch(this.urlValue, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': token
        },
        body: JSON.stringify({
          promotion_table_definition: { remove_on_promotion: checked }
        })
      });

      if (!res.ok) {
        // Revert UI on failure
        event.currentTarget.checked = !checked;
        const data = await res.json().catch(() => ({}));
        console.error('Failed to update remove_on_promotion', data);
      }
    } catch (e) {
      // Revert UI on failure
      event.currentTarget.checked = !checked;
      console.error('Error updating remove_on_promotion', e);
    }
  }
}
